// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"42":"77ab3fbe","436":"3bd15072","472":"cc570f6e","515":"0ccfc9f0","627":"767fabcf","927":"2cd0c275","940":"acc4a758","945":"f7e8b1ba"}[chunkId] + ".css";
};